import { useQueryClient } from '@tanstack/react-query';
import { useUnmarkPaidExternally } from '~/hooks/invoice/useUnmarkPaidExternally';
import { useUnvoidInvoice } from '~/hooks/invoice/useUnvoidInvoice';
import { useInvoiceUpdatedEvent } from '~/hooks/pusher/useInvoiceUpdatedEvent';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
export function useClientInvoiceActions(customerId) {
    const queryClient = useQueryClient();
    const { startUnvoidInvoice, finishUnvoidInvoice } = useUnvoidInvoice();
    const { startUnmarkPaidExternally, finishUnmarkPaidExternally } = useUnmarkPaidExternally();
    const refresh = ()=>{
        if (customerId == null) return Promise.resolve();
        return Promise.all([
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ClientBillingOverview,
                    customerId
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ClientFutureInvoices,
                    customerId
                ]
            })
        ]);
    };
    useInvoiceUpdatedEvent({
        onInvoiceRefetch: async ()=>{
            await refresh();
        },
        onUnvoided: finishUnvoidInvoice,
        onUnmarkedAsPaidExternally: finishUnmarkPaidExternally
    });
    return {
        refresh,
        startUnvoidInvoice,
        startUnmarkPaidExternally
    };
}
